import React, { createContext, useState, useContext, useMemo, useCallback } from 'react';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      title: "Thông báo bảo trì hệ thống",
      content: "Hệ thống sẽ bảo trì từ 23:00 ngày 30/10/2024 đến 01:00 ngày 31/10/2024. Trong thời gian này, một số tính năng có thể không khả dụng. Xin lỗi quý khách vì sự bất tiện này.",
      date: "2024-10-29 10:00",
      isRead: false
    },
    {
      id: 2,
      title: "Cập nhật chính sách mới",
      content: "Áp dụng chính sách mới về quy trình kiểm tra vé từ ngày 01/11/2024. Vui lòng đọc kỹ hướng dẫn để đảm bảo tuân thủ đúng quy trình.",
      date: "2024-10-28 15:30",
      isRead: false
    },
    {
      id: 3,
      title: "Thông báo nghỉ lễ",
      content: "Thông báo lịch nghỉ Tết Nguyên Đán 2025 từ ngày 28/01/2025 đến hết ngày 05/02/2025. Vui lòng sắp xếp công việc phù hợp.",
      date: "2024-10-27 09:15",
      isRead: false
    },
    {
      id: 4,
      title: "Họp nhân viên tháng 11",
      content: "Mời toàn thể nhân viên tham dự cuộc họp tổng kết tháng 11 vào lúc 14:00 ngày 05/11/2024 tại phòng họp chính.",
      date: "2024-10-26 16:45",
      isRead: true
    },
    {
      id: 5,
      title: "Cập nhật phần mềm",
      content: "Phiên bản mới 2.1.0 đã được cập nhật với nhiều tính năng mới. Vui lòng cập nhật để có trải nghiệm tốt nhất.",
      date: "2024-10-25 11:20",
      isRead: true
    },
    {
      id: 6,
      title: "Thông báo thay đổi giờ làm việc",
      content: "Từ ngày 01/12/2024, giờ làm việc sẽ được điều chỉnh: Sáng 8:00-12:00, Chiều 13:30-17:30.",
      date: "2024-10-24 14:00",
      isRead: true
    },
    {
      id: 7,
      title: "Chương trình đào tạo mới",
      content: "Khóa đào tạo kỹ năng phục vụ khách hàng sẽ được tổ chức vào ngày 15/11/2024.",
      date: "2024-10-23 09:30",
      isRead: true
    },
    {
      id: 8,
      title: "Thông báo sự cố kỹ thuật",
      content: "Hệ thống thanh toán đang gặp sự cố và đang được khắc phục. Vui lòng sử dụng phương thức thanh toán thay thế.",
      date: "2024-10-22 17:15",
      isRead: true
    },
    {
      id: 9,
      title: "Chính sách đồng phục mới",
      content: "Áp dụng quy định đồng phục mới từ tháng 12/2024. Chi tiết về mẫu đồng phục sẽ được thông báo sau.",
      date: "2024-10-21 10:00",
      isRead: false
    },
  ]);

  const unreadCount = useMemo(() => 
    notifications.filter(notification => !notification.isRead).length,
    [notifications]
  );

  const markAsRead = useCallback((notificationId) => {
    setNotifications(prev => 
      prev.map(notification => 
        notification.id === notificationId 
          ? { ...notification, isRead: true }
          : notification
      )
    );
  }, []);

  const markAllAsRead = useCallback(() => {
    setNotifications(prev =>
      prev.map(notification => ({ ...notification, isRead: true }))
    );
  }, []);

  const value = useMemo(() => ({
    notifications,
    setNotifications,
    unreadCount,
    markAsRead,
    markAllAsRead
  }), [notifications, unreadCount, markAsRead, markAllAsRead]);

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationContext);
} 